import { Component } from '@grafikr/components';
import Drawer from "utils/components/drawer";
import { NonNullish } from "../utils/nullish-check";
import Cart from 'utils/cart'
import fastdom from "fastdom";

export default Component((node, { dispatchEvent }) => {
  const drawer = new Drawer(node, {
    overlay: {
      index: 50
    }
  });
  const closeButtons = node.querySelectorAll<HTMLElement>('[data-close]');
  const form = NonNullish(node.querySelector<HTMLFormElement>('form[action="/cart/add"]'));
  const errorMessage = node.querySelector<HTMLElement>('[data-error]');

  const successWrapper = NonNullish(node.querySelector<HTMLElement>('[data-success]'));

  document.addEventListener('quick-buy-open', drawer.open);

  closeButtons.forEach(button => {
    button.addEventListener('click', () => {
      drawer.close();

      if (button.hasAttribute('data-load')) {
        setTimeout(() => {
          const cartDrawerTrigger = document.querySelector<HTMLElement>('[data-load="cart-drawer"]');
          if (cartDrawerTrigger) {
            cartDrawerTrigger.click();
          }
        }, 400);
      }
    })
  });

  drawer.on('close', () => {
    successWrapper.hidden = true;
    form.hidden = false;
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault()
    const formData = new FormData(form);

    formData.set('quantity', '1');

    if (!formData.get('selling_plan')) {
      formData.delete('selling_plan')
    }

    const { data, error } = await Cart.add(formData);

    if (data) {
      if (errorMessage) {
        fastdom.mutate(() => {
          errorMessage.hidden = true;
        });
      }

      form.hidden = true
      successWrapper.hidden = false

      dispatchEvent('cart:added', data);
    }

    if (error) {
      if (errorMessage) {
        fastdom.mutate(() => {
          errorMessage.hidden = false;
          errorMessage.textContent = error.description;
        });
      }

      dispatchEvent('cart:error', error);
    }

    document.dispatchEvent(new CustomEvent('cart:rerender'));
  });
});
